<template>
  <div
    class="workload_select"
  >
    <div
      class="workload_select_view"
      @click="toggleSelect"
    >
      <span>{{ selectedTitle }}</span>
    </div>
    <div :class="['workload_select_options gantt_scroll', isOpen ? 'open' : '']">
      <div
        v-for="item in options"
        :key="item.value"
        :class="['workload_select_options_item', item.value===selected.value ? 'active' : '']"
        @click="changeValue(item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WorkloadSelectMode',
  components: { },
  props: {
    options: {
      type: Array,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },

    ganttInstanceEventCaller: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: this.options.find(item => item.value === this.value),
    };
  },
  computed: {
    selectedTitle() {
      return this.options.find(item => item.value === this.selected.value).title;
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.close);
  },
  methods: {
    toggleSelect() {
      this.isOpen = !this.isOpen;
    },

    changeValue(option) {
      this.isOpen = !this.isOpen;

      if (this.selected.value === option.value) {
        return;
      }

      this.selected = option;
      this.ganttInstanceEventCaller('onChangeWorkloadCalculationMode', [option.value]);
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style scoped src='./style.less'></style>
